export default __webpack_public_path__ + "static/media/27_2_2.3ec51d23.png";